import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import * as Yup from "yup";
import { Link, useParams } from "react-router-dom";
 
import ReactImageFallback from "react-image-fallback";
import { FiArrowLeft } from "react-icons/fi";
import { BsFillCameraFill } from "react-icons/bs";
import { updateProfile } from "../../redux/features/authHandler.feature";
import Footer1 from "../../components/Footers/Footer1.component";
import AuthHeader from "../../components/Headers/AuthHeader.component";


// images
import defaultUser from "../../assets/images/default_profile_pic.jpg";



export default function EditUserProfile() {
  const { id } = useParams();
  const dispatch = useDispatch();

  // local state 
  const [flag, setFlag] = useState("");
  // const [profileImage, setProfileImage] = useState(null);
  // Redux State
  const token = useSelector(state => state.auth.token);
  const userData = useSelector(state => state.auth.data);

  const formik = useFormik({
    initialValues: {
      firstName: userData?.first_name ?? "",
      lastName: userData?.last_name ?? "",
      mobileNumber: userData?.phone_number ?? "",
      address: userData?.address ?? "",
      email: userData?.email ?? "",
      profilePhoto: userData?.profile_image ?? null,
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .min("3", "Must have atleast 3 characters.")
        .required("Required"),
      lastName: Yup.string()
        .min("3", "Must have atleast 3 characters.")
        .required("Required"),
      address: Yup.string().required("Required"),
      mobileNumber: Yup.number()
        .min("7", "Must have atleast 7 characters.")
        .required("Required"),
      email: Yup.string().email().required("Required"),
    }),
    onSubmit: async (values) => {
      var form = new FormData();
      form.append('profile_image', values.profilePhoto); 

      form.append('profile_id',id);
      form.append('first_name',values.firstName);
      form.append('last_name',values.lastName);
      form.append('phone_number',values.mobileNumber);
      form.append('address',values.address);

      await fetch(`${process.env.REACT_APP_BASE_URL}/api/update_profile`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
        body:form
      })
        .then((r) => r.json())
        .then((response) => {
          if (response.success) {
            setFlag({ status: "success", message: response.message });
            // let serializedData = JSON.stringify(response.records);
            // localStorage.setItem("data", serializedData);
            let tmp = {};
            tmp.data = response.records;
            dispatch(updateProfile(tmp));
            //   router.push("/profile");
          } else {
            setFlag({ status: "failed", message: response.message });
            console.log("Error!", response);
          }
        });
    },
  });


  const handleProfileImage = (e) => {
    let img = e.target.files[0]; 
    formik.setFieldValue("profilePhoto", img);    
  };

  // console.log(formik.values);

  return (
    <>
    <AuthHeader />
      <section className="bds-main-section">
        <div className="container">
          <div className="row">
            <div className="col-xl-6">
              <div className="bds-sectiontitle user-profile">
                <div className="bds-featureRating">
                  <p>
                      <Link to="/profile" className="btn px-0 d-flex align-items-center text-sky-blue">
                        <FiArrowLeft />
                        <span className="ms-2">Back to Profile</span>                      
                    </Link>
                  </p>
                  <h3 className="mb-2">Edit Profile</h3>

                  <div className="bds-box">
                    <form
                      className="bds-themeform"
                      onSubmit={formik.handleSubmit}
                      encType="multipart/form-data"
                    >
                      <fieldset>
                        <div className="bds-themeform__wrap">
                          <div className="form-group flex-column">
                            <div className="edit_profile_photo">
                              
                              <ReactImageFallback
                                src={`https://3bidsapp.com/dev/public/storage/${userData?.profile_image}`}                                
                                fallbackImage={defaultUser}
                                initialImage={defaultUser}
                                alt="user image"
                                width={"180px"}
                                height={"180px"}
                                 
                                className="rounded-circle d-block bg-secondary"
                              />
                              <input
                                type="file"
                                name="profilePhoto"
                                id="profilePhoto"
                                className="d-none"                                
                                onChange={(e) => handleProfileImage(e)}
                              />
                              <button
                                type="button"
                                className="btn rounded-circle shadow-lg py-1 px-2"
                                onClick={() => {
                                  document
                                    .getElementById("profilePhoto")
                                    .click();
                                }}
                              >
                                <BsFillCameraFill />
                              </button>
                            </div>
                          </div>

                          <div className="form-group flex-column align-items-start">
                            <div
                              className={`bds-placeholderholder ${formik.touched.firstName &&
                                formik.errors.firstName
                                ? "border border-danger"
                                : ""
                                }`}
                            >
                              <input
                                name="firstName"
                                type="text"
                                className={`form-control bds-themeinput`}
                                placeholder="First Name"
                                value={formik.values.firstName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <p className="m-0">
                              {formik.touched.firstName &&
                                formik.errors.firstName ? (
                                <small className="text-danger">
                                  {formik.errors.firstName}
                                </small>
                              ) : null}
                            </p>
                          </div>
                          <div className="form-group flex-column align-items-start">
                            <div
                              className={`bds-placeholderholder ${formik.touched.lastName &&
                                formik.errors.lastName
                                ? "border border-danger"
                                : ""
                                }`}
                            >
                              <input
                                name="lastName"
                                type="text"
                                className={`form-control bds-themeinput`}
                                placeholder="Last Name"
                                value={formik.values.lastName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <p className="m-0">
                              {formik.touched.lastName &&
                                formik.errors.lastName ? (
                                <small className="text-danger">
                                  {formik.errors.lastName}
                                </small>
                              ) : null}
                            </p>
                          </div>
                          <div className="form-group flex-column align-items-start">
                            <div
                              className={`bds-placeholderholder ${formik.touched.username &&
                                formik.errors.username
                                ? "border border-danger"
                                : ""
                                }`}
                            >
                              <input
                                name="email"
                                type="email"
                                className={`form-control bds-themeinput`}
                                placeholder="Email Address"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <p className="m-0">
                              {formik.touched.email && formik.errors.email ? (
                                <small className="text-danger">
                                  {formik.errors.email}
                                </small>
                              ) : null}
                            </p>
                          </div>
                          <div className="form-group flex-column align-items-start">
                            <div
                              className={`bds-placeholderholder ${formik.touched.mobileNumber &&
                                formik.errors.mobileNumber
                                ? "border border-danger"
                                : ""
                                }`}
                            >
                              <input
                                name="mobileNumber"
                                type="text"
                                className={`form-control bds-themeinput`}
                                placeholder="Mobile Number"
                                value={formik.values.mobileNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <p className="m-0">
                              {formik.touched.mobileNumber &&
                                formik.errors.mobileNumber ? (
                                <small className="text-danger">
                                  {formik.errors.mobileNumber}
                                </small>
                              ) : null}
                            </p>
                          </div>
                          <div className="form-group flex-column align-items-start">
                            <div
                              className={`bds-placeholderholder ${formik.touched.address && formik.errors.address
                                ? "border border-danger"
                                : ""
                                }`}
                            >
                              <input
                                name="address"
                                type="text"
                                className={`form-control bds-themeinput`}
                                placeholder="Address"
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </div>
                            <p className="m-0">
                              {formik.touched.address &&
                                formik.errors.address ? (
                                <small className="text-danger">
                                  {formik.errors.address}
                                </small>
                              ) : null}
                            </p>
                          </div>

                          <div className="bds-popup-terms form-group">
                            <button
                              type="submit"
                              name="submit"
                              className="bds-btn-solid-lg"
                            >
                              Save
                            </button>
                          </div>
                          {flag.status == "success" && (
                            <div
                              className="alert alert-success alert-dismissible fade show w-100 "
                              role="alert"
                            >
                              {flag.message}
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                              ></button>
                            </div>
                          )}
                          {flag.status == "failed" && (
                            <div
                              className="alert alert-danger alert-dismissible fade show w-100"
                              role="alert"
                            >
                              {flag.message}
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                              ></button>
                            </div>
                          )}
                        </div>
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer1 />
    </>
  );
}
